import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

// import videoL01 from '../assets/videos/2018/NISSAN_DirCut_HQ LONG.mp4';
// import videoL02 from '../assets/videos/2018/Samsung QLED Color Volume LONG.mp4';
// import videoL03 from '../assets/videos/2018/Sofi Tukker and Pabllo Vittar - Energia LONG.mp4';
// import videoL04 from '../assets/videos/2018/Oddballs Squarespace.mp4';
// import videoL05 from '../assets/videos/2018/Bricolage Squarespace LONG.mp4';
// import videoL06 from '../assets/videos/2018/Hello Clay Squarespace.mp4';
// import videoL07 from '../assets/videos/2018/Vodafone - Home LONG.mp4';
// import videoL08 from '../assets/videos/2018/BMW LONG.mp4';
// import videoL09 from '../assets/videos/2018/Heineken - After Hours LONG.mp4';
// import videoL10 from '../assets/videos/2018/Old Spice - Marco LONG.mp4';
// import videoL11 from '../assets/videos/2018/Old Spice - Red Sweater LONG.mp4';
// import videoL12 from '../assets/videos/2018/OOFOS - RECOVER FASTER FEEL THE OO LONG.mp4';
// import videoL13 from '../assets/videos/2018/Borgward - Dream LONG .mp4';
// import videoL14 from '../assets/videos/2017/1025_IconX_fitnesscoaching.mp4';
// import videoL15 from '../assets/videos/2016/KEYSTONE CHEVROLET.mp4';
// import videoL16 from '../assets/videos/2016/Moccona - Lovers of Coffee.mp4';
// import videoL17 from '../assets/videos/2015/HYUNDAI - STORY TELLING.mp4';
// import videoL18 from '../assets/videos/2015/MARIONET 30S.mp4';
// import videoL19 from '../assets/videos/2015/MAZDA CX3 DRUMS.mp4';
// import videoL20 from '../assets/videos/2015/MAZDA CX3 HANDS.mp4';
// import videoL21 from '../assets/videos/2015/MAZDA M2 - NIGHT SURF.mp4';
//
// import videoS02 from '../assets/videos/2018/Samsung QLED Color Volume SHORT.mp4';
// import videoS05 from '../assets/videos/2018/Bricolage Squarespace SHORT.mp4';
// import videoS12 from '../assets/videos/2018/OOFOS - RECOVER FASTER FEEL THE OO SHORT.mp4';
//
// import workImage01 from '../assets/thumbs/Nissan.png';
// import workImage02 from '../assets/thumbs/samsung_QLED.png';
// import workImage03 from '../assets/thumbs/Sofi_Tukker_and_Pabllo_Vittar_Energia.png';
// import workImage04 from '../assets/thumbs/Oddballs_Squarespace.png';
// import workImage05 from '../assets/thumbs/Bricolage_Squarespace.png';
// import workImage06 from '../assets/thumbs/Hello_Clay_Squarespace.png';
// import workImage07 from '../assets/thumbs/Vodafone_Home.png';
// import workImage08 from '../assets/thumbs/BMW.png';
// import workImage09 from '../assets/thumbs/Heineken_After_Hours.png';
// import workImage10 from '../assets/thumbs/Old_Spice_Marco.png';
// import workImage11 from '../assets/thumbs/Old_Spice_Red_Sweater.png';
// import workImage12 from '../assets/thumbs/OOFOS_RECOVER_FASTER_FEEL_THE_OO.png';
// import workImage13 from '../assets/thumbs/Borgward_Dream.png';
// import workImage14 from '../assets/thumbs/fitnesscoaching.png';
// import workImage15 from '../assets/thumbs/CHEVROLET.png';
// import workImage16 from '../assets/thumbs/Moccona_Lovers_of_Coffee.png';
// import workImage17 from '../assets/thumbs/HYUNDAI_STORY_TELLING.png';
// import workImage18 from '../assets/thumbs/MARIONET_30S.png';
// import workImage19 from '../assets/thumbs/MAZDA_CX3_DRUMS.png';
// import workImage20 from '../assets/thumbs/MAZDA_CX3_HANDS.png';
// import workImage21 from '../assets/thumbs/MAZDA_M2_NIGHT_SURf.png';
//
// import teamMember01 from '../assets/team/Patricia Lino.png'
// import teamMember02 from '../assets/team/Carla Lopes.png'
// import teamMember03 from '../assets/team/Susana Oliveira.png'
// import teamMember04 from '../assets/team/Sofia Noronha.png'
// import teamMember05 from '../assets/team/Paula Miguel.png'
// import teamMember06 from '../assets/team/Patricia Nunes.png'
// import teamMember07 from '../assets/team/Anastasia Marto.png'
// import teamMember08 from '../assets/team/Ricardo Conde.png'
// import teamMember09 from '../assets/team/Francisco Gomes.png'
// import teamMember10 from '../assets/team/Ana Lavaredas.png'
//
// import locationImage01 from '../assets/thumbs/Nissan.png';
// import locationImage02 from '../assets/thumbs/samsung_QLED.png';
// import locationImage03 from '../assets/thumbs/Sofi_Tukker_and_Pabllo_Vittar_Energia.png';
// import locationImage04 from '../assets/thumbs/Oddballs_Squarespace.png';
// import locationImage05 from '../assets/thumbs/Bricolage_Squarespace.png';
// import locationImage06 from '../assets/thumbs/Hello_Clay_Squarespace.png';
// import locationImage07 from '../assets/thumbs/Vodafone_Home.png';
// import locationImage08 from '../assets/thumbs/BMW.png';
//
// import directorImageF01 from '../assets/man-red.png';
// import directorImageB01 from '../assets/man.png';

const env = process.env.NODE_ENV;

const state = {
  showVideo: false,
  videoType: '',
  showMenu: false,
  openedBars: true,
  baseUrl: env === 'production' ? '/umbraco/api' : 'http://psp.stage.8interactive.pt/umbraco/api',
  lang: 'en',
  works: [],
  worksLongFormat: [],
  teamMembers: [],
  partners: [],
  locations: [],
  clients: [],
  directors: [],
  homeCopy: {},
  worksCopy: {},
  locationsCopy: {},
  directorsCopy: {},
  contactsCopy: {},
  aboutusCopy: {},
  clientsCopy: {},
  productionsCopy: {},
  worksLongFormatCopy: {},
  config: {}
};

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js